<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container style="postion:fixed; top:0px !important; " >
  <c-container [fluid]="true" class=" px-4">
    <button
      [cSidebarToggle]="sidebarId()"
      cHeaderToggler
      class="btn d-block d-xl-none navs-btn"
      toggle="visible"
      style="margin-inline-start: -14px;"
      aria-label="Toggle sidebar navigation"
    >
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>
	 <c-breadcrumb-router  class="d-xl-inline d-none"/>
	
    <c-header-nav class="d-none">
      <c-nav-item>
        <a cNavLink routerLink="/dashboard" routerLinkActive="active">Dashboard</a>
      </c-nav-item>
      <c-nav-item>
        <a cNavLink routerLink="/users" routerLinkActive="active">Users</a>
      </c-nav-item>
      <c-nav-item>
        <a cNavLink routerLink="/settings" routerLinkActive="active">Settings</a>
      </c-nav-item>
    </c-header-nav>

    <c-header-nav class="d-none ms-auto ">
      <a cNavLink>
        <svg cIcon class="my-1" name="cilBell" size="lg"></svg>
      </a>
      <a cNavLink>
        <svg cIcon class="my-1" name="cilList" size="lg"></svg>
      </a>
      <a cNavLink>
        <svg cIcon class="my-1" name="cilEnvelopeOpen" size="lg"></svg>
      </a>
    </c-header-nav>

    <c-header-nav class="d-none ms-auto ms-md-0">
      <div class="nav-item py-1">
        <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
      </div>
      <ng-container *ngTemplateOutlet="themeDropdown" />
      <div class="nav-item py-1">
        <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
      </div>
    </c-header-nav>

    <c-header-nav class="mx-0">
      <ng-container *ngTemplateOutlet="userDropdown" />
    </c-header-nav>

  </c-container>
 <!-- <c-container [fluid]="true" class="px-4">
    <c-breadcrumb-router />
  </c-container>-->
</ng-container>
<!--</c-header>-->

<ng-template #userDropdown>
  <c-dropdown [popperOptions]="{ placement: 'bottom-start' }" variant="nav-item" >
    <button [caret]="false" cDropdownToggle class="py-0 pe-0 flaot-end text-start" aria-label="Open user menu">
      <c-avatar
        shape="rounded-1"
        [size]="'md'"
        src="./assets/images/avatars/8.jpg"
        status="success"
        textColor="primary"
        alt="User avatar"
		class="d-none"
      />
	  <div class="user-auth">
	  <div class="user-icons me-2">{{ userInitials() }}</div>
	  <div class="user-auth-details text-left d-xl-inline d-none"><span class="d-block"><small>Hello,</small></span>{{ firstname }} {{ lastname }}</div>
	  </div>
    </button>
    <ul cDropdownMenu class="pt-0 w-auto">
      
      <li>
        <a cDropdownItem routerLink="/home/customer-profile">
           <img src="./assets/images/my-profile.svg" class="me-2" name="user"  title=" My Profile"/>
          My Profile
        </a>
      </li>
      <li  (click)="signOut()">
        <a cDropdownItem routerLink="/home-page">
          <img src="./assets/images/sign-out.svg" class="me-2" name="user"  title=" My Profile"/>
          Sign Out
        </a>
      </li>
    </ul>
  </c-dropdown>
</ng-template>

<ng-template #themeDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle aria-label="Open theme picker">
      <svg cIcon [name]="icons()" size="lg"></svg>
    </button>
    <div cDropdownMenu>
      @for (mode of colorModes; track mode.name) {
        <button
          (click)="colorMode.set(mode.name)"
          [active]="colorMode()===mode.name"
          cDropdownItem
          class="d-flex align-items-center"
        >
          <svg cIcon class="me-2" [name]="mode.icon" size="lg"></svg>
          {{ mode.text }}
        </button>
      }
    </div>
  </c-dropdown>
</ng-template>
